import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
};

export const gbp = (pence) =>
  `£${((pence ?? 0) / 100).toLocaleString("en-GB", { minimumFractionDigits: (pence ?? 0) % 100 ? 2 : 0 })}`;
